import { render, staticRenderFns } from "./AuthWrap.vue?vue&type=template&id=2acc0182&"
import script from "./AuthWrap.vue?vue&type=script&lang=js&"
export * from "./AuthWrap.vue?vue&type=script&lang=js&"
import style0 from "./AuthWrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VOverlay,VRow})
